import { BrandVariants, createLightTheme } from "@fluentui/react-components";

const customBrandRamp: BrandVariants = {
  10: "#0a2e4a",
  20: "#2f2f4a",
  30: "#333357",
  40: "#383966",
  50: "#3d3e78",
  60: "#444791",
  70: "#0E1823",
  80: "#0a2e4a",
  90: "#7579eb",
  100: "#7f85f5",
  110: "#9299f7",
  120: "#aab1fa",
  130: "#b6bcfa",
  140: "#c5cbfa",
  150: "#dce0fa",
  160: "#e8ebfa",
};

export const customLightTheme = createLightTheme(customBrandRamp);
